// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__k7PF-","paid":"Badge_paid__36Xj6"};